import Vue from 'vue'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import VueSweetAlert from 'vue-sweetalert'

import MeiParaMe from './components/MeiParaMe'
import ContabilidadeOnline from './components/ContabilidadeOnline'
import AbrirEmpresa from './components/AbrirEmpresa'

import locale from 'element-ui/lib/locale/lang/pt-br'

Vue.use(VueResource)
Vue.use(ElementUI, { locale })
Vue.use(VueSweetAlert)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {
    MeiParaMe,
    ContabilidadeOnline,
    AbrirEmpresa
  }
})



// WEBPACK FOOTER //
// ./src/main.js